module.exports = __webpack_public_path__ + "public/images/lock.f7f5b1c93c0ee90aa56c3e015fa1c4d3.svg";